/**
 * Converts milliseconds to minutes
 * @param milliseconds number
 * @returns number
 * @example toMinutes(60000) // 1
 */
export function toMinutes(milliseconds: number): number {
  return Math.floor(milliseconds / 60000);
}
